    <template>
    <main>
        <header class="banner solutions vis-solution">
            <div class="container">
                <div class="text-left">
                    <router-link tag="a" to="/solucoes" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> voltar para SOLUÇÕES</router-link>
                </div>
                <h1>Visualização de Dados</h1>
                <h4>para negócios de alto impacto</h4>
            </div>
            <div class="clip-path-one green70">
                <span class="arrow-header"></span>
            </div>
        </header>

        <section class="solution-intro">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        Possuímos equipe especializada em inteligência e análise de negócios (Business Intelligence) para desenvolvimento de painéis de visualizações integrados com as bases de dados da sua organização.
                    </div>
                </div>
            </div>
        </section>

        <section class="solution-items">

            <solution-item v-for="(item, i) of data.solutionItems" :data="item" :number="i + 1" :key="i"></solution-item>

        </section>

        <section class="parallax vis-solution"></section>

        <testimonials-carousel></testimonials-carousel>

        <section class="cta-solutions">
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <router-link tag="a" to="/solucoes/comunicacao-institucional" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> voltar Comunicação Instutucional</router-link>
                    </div>
                    <div class="col-md-6">
                        <h1>Quer ver <br>mais soluções?</h1>
                    </div>
                    <div class="col-md-3">
                        <router-link tag="a" to="/solucoes/projetos-personalizados" class="btn btn-viitra-dark">Ver Projetos Personalizados <i class="fas fa-chevron-right"></i></router-link>
                    </div>
                </div>
            </div>
            <div class="path opacity40"></div>
            <div class="path opacity60"></div>
            <div class="path opacity80"></div>
        </section>
        
        <section class="cta-solutions mobile">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>Quer ver <br>mais soluções?</h1>
                    </div>
                    <div class="col-md-12">
                        <router-link tag="a" to="/solucoes/comunicacao-institucional" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> voltar Comunicação Instutucional</router-link>
                    </div>
                    <div class="col-md-12">
                        <router-link tag="a" to="/solucoes/projetos-personalizados" class="btn btn-viitra-dark">Ver Projetos Personalizados <i class="fas fa-chevron-right"></i></router-link>

                    </div>
                </div>
            </div>
            <div class="path opacity40"></div>
            <div class="path opacity60"></div>
            <div class="path opacity80"></div>
        </section>
    </main>
</template>

<script>
    export default {
        data() {
            return {
                data: {
                    solutionItems: [
                        {
                            title: 'Integração com Bases de Dados Organizacionais',
                            description: `
                                <p>O sistema importará dados de arquivos, feeds, bancos de dados, unidades na nuvem e aplicações corporativas para serem processados de acordo com a necessidade do cliente.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/analytics/vis-figure-9.jpg'
                            },
                        },
                        {
                            title: 'Configuração de Métricas',
                            description: `
                                <p>Nossa equipe de especialistas irá analisar os dados e desenvolver funções matemáticas e estatísticas específicas para extrair as métricas de negócios necessárias para processar suas informações.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/analytics/vis-figure-1.jpg'
                            },
                        },
                        {
                            title: 'Painéis de Visualização Dinâmica (Gráficos e Infográficos)',
                            description: `
                                <p>Combinamos vários relatórios em um único painel dinâmico com imagens, gráficos e infográficos para tornar mais fácil e eficaz o monitoramento de KPIs (Key Performance Indicators, principais indicadores de desempenho) por executivos/usuários.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/analytics/vis-figure-4.jpg'
                            },
                        },
                        {
                            title: 'Controle de Acesso',
                            description: `
                                <p>Tenha controle total sobre o que os usuários podem ver e fazer com os relatórios e visualizações que você compartilha com eles.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/analytics/vis-figure-5.jpg'
                            },
                        },
                        {
                            title: 'Geração de Relatórios',
                            description: `
                                <p>Configure os tipos de relatórios e as informações presentes que poderão ser gerados por usuários com/sem logins.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/analytics/vis-figure-8.jpg'
                            },
                        },
                        {
                            title: 'BI Integrado',
                            description: `
                                <p>Nossa solução é integrada com ferramentas de BI. Oferecemos uma opção de business intelligence que possibilita a geração relatórios e painéis prontos para os usuários encontrarem o valor que esperam.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/analytics/vis-figure-7.jpg'
                            },
                        },
                        {
                            title: 'Big Data',
                            description: `
                                <p>Analise suas informações críticas de Big Data com facilidade e aproveite os principais insights de negócios. As informações ficam armazenadas em bancos de dados relacionais, NoSQL e em nuvem.</p>
                            `,
                            imageArea: {
                                type: '',
                                src: ''
                            },
                        },
                    ]
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/solutions/Vis.vue